import React from "react";
import styled from "styled-components";

import { Description } from "../../components";
import Tools from "../../img/louis-hansel-shotsoflouis-unsplash.jpg";
import DrumPad from "../../img/samuel-ramos-unsplash.jpg";

const Projects = () => {
  return (
    <ul>
      <Item>
        <Description
          title="Drum pad"
          copy="A digital dram pad synthesizer"
          link="https://github.com/genechan/drumPad"
          image={DrumPad}
          layout="right"
        />
      </Item>
      <Item>
        <Description
          title="Default build"
          copy="This is my current coding project setup. When I try a new technology, I spin this up to start coding when minutes."
          link="https://github.com/genechan/defaultSetup"
          image={Tools}
          layout="left"
        />
      </Item>
    </ul>
  );
};
const Item = styled.li`
  list-style: none;
`;
export default Projects;
